import React from "react";
import { Loader2 } from "lucide-react";

/**
 * ActionButton — unified button.
 * variant: "primary" | "secondary" | "destructive" | "ghost"
 * size: "sm" | "md" | "lg"
 */
const VARIANTS = {
  primary:
    "bg-onedesk-primary text-white border border-onedesk-primary hover:bg-onedesk-primary/90 focus-visible:ring-onedesk-primary/30",
  secondary:
    "bg-onedesk-card text-onedesk-textPrimary border border-onedesk-border hover:border-onedesk-primary focus-visible:ring-onedesk-primary/20",
  destructive:
    "bg-onedesk-danger text-white border border-onedesk-danger hover:bg-onedesk-danger/90 focus-visible:ring-onedesk-danger/30",
  ghost:
    "bg-transparent text-onedesk-textPrimary border border-transparent hover:bg-onedesk-bg focus-visible:ring-onedesk-primary/20",
};

const SIZES = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
};

export default function ActionButton({
  variant = "primary",
  size = "md",
  Icon,
  loading = false,
  disabled = false,
  children,
  className = "",
  testId,
  type = "button",
  ...props
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      data-testid={testId || `btn-${variant}`}
      className={`inline-flex items-center justify-center gap-2 rounded-od-btn font-bold uppercase tracking-wider transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
        VARIANTS[variant]
      } ${SIZES[size]} ${
        isDisabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
      {...props}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.5} />
      ) : (
        Icon && <Icon className="h-4 w-4" strokeWidth={2.5} />
      )}
      {children}
    </button>
  );
}
